
const it = {
    superAdmin: {
        list: 'Elenco Parametri Super Admin',
        varName: 'Nome Variabile',
        varValue: 'Valore Variabile',
        varList: 'Elenco Variabili',
        tabName: {
            varList: 'Elenco Variabili',
            varDetails: 'Dettagli Variabile',
            VARIABLES: 'Variabili',
            CODE_TABLES: 'Code Tables'

        }
    },
    codeTablesName: {
        list: 'Elenco Tabelle Codice',
        tableName: 'Nome Tabella',
        description: 'Descrizione',
        paramType: {
            label: 'Tipo Parametro',
            NONE: 'Nessuno',
            SOLUTION: 'Soluzione'
        },
        showDetail: 'Mostra Dettagli',
        tabName: {
            list: 'Elenco Tabelle Codice',
            details: 'Dettagli Tabella Codice',
            CODE_TABLES: 'Tabelle Codice',

        }
    },
    codeTables: {
        list: 'Elenco Codici',
        mutateSubtitle: 'Modifica Codici',
        code: 'Codice',
        description: 'Descrizione',
        valueNum: 'Valore Numerico',
        valueStr: 'Valore Stringa',
        parameter: {
            label: 'Parametri',
            solution: {
                label: 'Soluzione',
                description: 'Descrizione della Soluzione',
                parA: 'Parametro A',
                parB: 'Parametro B',
                parC: 'Parametro C',
                parS: 'Parametro S',
                par0: 'Parametro Ø'
            }
        },
        orderIndex: 'Indice Ordine',
        thumbnail: 'Miniatura',
        image: 'Immagine',
    }

}
export default it